<template>
  <div class="clearfix">
    <a
      class="tender-back-link"
      @click="doNav()"
    >
      <i
        class="fa fa-angle-left"
        aria-hidden="true"
      />{{ $t('home') }}</a>
  </div>
</template>

<script>
import navitaion from '@/utils/navigation'

export default {
  name: 'HomeLink',
  methods: {
    doNav () {
      navitaion.toHome()
    },
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';
.tender-back-link {
  font-family: Verdana;
  padding-top: 15px;
  font-size: 14px;
  color: $tender-font-color;

  i {
    margin-right: 0.5vw;
    font-size: 16px;
  }
}
</style>
